import React from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { FaMicrosoft } from 'react-icons/fa';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import MailOutlineIcon from '@mui/icons-material/MailOutlined';
import { AppButton } from '../../../components/UI';

const STEPS = [
  { icon: <MarkEmailReadOutlinedIcon />, title: 'Lecture des emails', text: 'GoMail parcourt votre boîte Outlook et récupère les CV reçus en pièce jointe.' },
  { icon: <AutoAwesomeOutlinedIcon />, title: 'Analyse par IA', text: 'Chaque CV est analysé : contact, compétences, expérience, LinkedIn vérifié.' },
  { icon: <PersonAddAlt1OutlinedIcon />, title: 'Ajout au CRM', text: 'Recherchez en langage naturel et créez le candidat dans le CRM en un clic.' },
];

const GoMailConnect = ({ connecting, error, onLogin }) => (
  <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: { xs: 2, md: 4 } }}>
    <Box sx={{ width: '100%', maxWidth: 760, bgcolor: '#fff', border: '1px solid #e2e8f0', borderRadius: '16px', boxShadow: '0 4px 24px rgba(15,23,42,0.05)', overflow: 'hidden' }}>
      <Box sx={{ p: { xs: 3, md: 4 }, textAlign: 'center', borderBottom: '1px solid #eef2f7' }}>
        <Box sx={{ width: 56, height: 56, mx: 'auto', borderRadius: '16px', background: 'linear-gradient(135deg, #0556a4, #03407b)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 6px 18px rgba(3,64,123,0.25)' }}>
          <MailOutlineIcon />
        </Box>
        <Typography sx={{ mt: 2, fontSize: '1.3rem', fontWeight: 800, color: '#0f172a' }}>Connectez votre boîte Outlook</Typography>
        <Typography sx={{ mt: 0.5, fontSize: '0.88rem', color: '#64748b', maxWidth: 480, mx: 'auto' }}>
          GoMail transforme les CV reçus par email en candidats prêts à être ajoutés au CRM.
        </Typography>
        <AppButton
          size="large"
          startIcon={connecting ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : <FaMicrosoft />}
          onClick={onLogin}
          disabled={connecting}
          sx={{ mt: 3, px: 3.5 }}
        >
          {connecting ? 'Connexion en cours…' : 'Se connecter avec Microsoft'}
        </AppButton>
        {connecting && (
          <Typography sx={{ mt: 1.25, fontSize: '0.78rem', color: '#64748b' }}>
            Terminez la connexion dans la fenêtre Microsoft ouverte : cette page se mettra à jour toute seule.
          </Typography>
        )}
        {error && (
          <Alert severity="warning" sx={{ mt: 2, textAlign: 'left', borderRadius: '10px' }}>{error}</Alert>
        )}
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' }, bgcolor: '#f8fbfe' }}>
        {STEPS.map((s, i) => (
          <Box key={s.title} sx={{ p: 2.5, borderLeft: { sm: i ? '1px solid #e2edf7' : 'none' }, borderTop: { xs: i ? '1px solid #e2edf7' : 'none', sm: 'none' } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#03407b', '& svg': { fontSize: 20 } }}>
              {s.icon}
              <Typography sx={{ fontSize: '0.86rem', fontWeight: 800, color: '#0f172a' }}>{i + 1}. {s.title}</Typography>
            </Box>
            <Typography sx={{ mt: 0.75, fontSize: '0.78rem', color: '#64748b', lineHeight: 1.5 }}>{s.text}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);

export default GoMailConnect;
